import dayjs from "dayjs";

export type EntryIdFields = {
  meid?: string | null;
  partid?: string | null;
  lbeid?: string | null;
};

export const resolveEntryId = (entry?: EntryIdFields | null): string | null =>
  entry?.meid ?? entry?.partid ?? entry?.lbeid ?? null;

export const mapLogbookEntriesForSelect = (entries: any[]) =>
  entries.map(
    ({
      lbid,
      lbeid,
      partid,
      meid,
      datecreated,
      sortdate,
      status,
      autosave,
      ...props
    }: any) => ({
      label: dayjs(sortdate || datecreated).format("D MMM YYYY - HH:mm"),
      status,
      value: resolveEntryId({ meid, partid, lbeid }),
      lbid,
      partid,
      meid,
      autosave,
      patient: props?.patient ?? null,
    }),
  );

export const isNewEntryRouteId = (id?: string | null) =>
  !id || id === "new" || id.includes("new=");
